module.exports = __webpack_public_path__ + "img/minjiang2.a6f6541a.png";